$(document).ready(function ($) {
    let currentStep = 1;
    const selections = {};

    function showStep(step) {
        if (step !== 1) {
            $(".multi-step-page").addClass("hidden-image-box");
        } else {
            $(".multi-step-page").removeClass("hidden-image-box");
        }
        $(".step").removeClass("active").css("opacity", 0);
        const $step = $(`.step[data-step="${step}"]`);
        $step.addClass("active");
        setTimeout(() => $step.css("opacity", 1), 10);

        if (currentStep === 4 && step === 5) {
            const btn = $(".btn-final-step");
            const targetUrl = btn.attr("href");
            const tableName = btn.data("table");

            jQuery.ajax({
                url: ajaxurl,
                type: "POST",
                dataType: "json",
                data: {
                    action: "save_user_selections",
                    data: JSON.stringify(selections),
                    table: tableName,
                },
                success: function(response) {
                    console.log("Response:", response);
                },
                error: function(xhr, status, error) {
                    console.error("Error AJAX:", error);
                }
            });

            setTimeout(() => {
                window.location.href = targetUrl;
            }, 2000);
        }

        currentStep = step;
    }

    $(".option").on("click", function () {
        $(this).siblings().removeClass("selected");
        $(this).addClass("selected");

        const stepNumber = $(this).closest(".options").data("options");
        selections[`${stepNumber}`] = $(this).data("value");
    });

    $(".next").on("click", function (e) {
        if (currentStep < 5) {
            showStep(currentStep + 1);
        }
    });

    $(".back").on("click", function () {
        if (currentStep > 1) {
            showStep(currentStep - 1);
        }
    });
});